var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 41.4",
    style: {
      enableBackground: "new 0 0 100 41.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2,0.9L13,40.3H0.8L9.9,0.9H22.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2,40.3l9.1-39.5h19.8c3.8,0,6.8,0.8,9,2.5c2.2,1.7,3.3,3.9,3.3,6.8c0,2-0.4,3.8-1.3,5.3s-2.1,2.7-3.5,3.6 c-1.5,0.9-3.1,1.5-4.9,1.8v0.1c2.3,0.2,4.1,0.9,5.5,2.3c1.4,1.4,2.1,3.1,2.1,5.3c0,2.7-0.6,4.9-1.9,6.6c-1.3,1.7-3.1,3-5.4,3.9 c-2.3,0.9-5.1,1.3-8.2,1.3H20.2z M33.8,32.1h7.8c1.7,0,3.1-0.3,4-1c1-0.7,1.5-1.6,1.5-3c0-0.7-0.1-1.2-0.4-1.7 c-0.3-0.5-0.7-0.8-1.3-1C44.7,25.1,44,25,43,25h-7.5L33.8,32.1z M37.5,16.6h6.3c1.1,0,2.1-0.2,2.8-0.5c0.8-0.3,1.4-0.8,1.8-1.4 c0.4-0.6,0.6-1.3,0.6-2.1c0-1-0.4-1.8-1.1-2.3c-0.7-0.5-1.7-0.7-2.9-0.7h-6L37.5,16.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.1799,
    y1: 20.6875,
    x2: 99.2261,
    y2: 20.6875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00120932,
    style: {
      stopColor: "#EBB23B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1292,
    style: {
      stopColor: "#EAAA39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4076,
    style: {
      stopColor: "#E99D35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6944,
    style: {
      stopColor: "#E99633"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E99333"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.2,41c-2.4,0-4.6-0.2-6.8-0.7c-2.2-0.5-4.1-1.2-5.8-2.2c-1.7-1-3-2.2-4-3.6c-1-1.5-1.5-3.2-1.5-5.1 c0-2,0.4-3.7,1.3-5.1c0.8-1.4,2-2.5,3.5-3.3c1.5-0.8,3.2-1.4,5.2-1.7l-0.1,0.1c-1-0.6-1.9-1.2-2.7-2c-0.7-0.8-1.3-1.6-1.7-2.6 s-0.6-2-0.6-3.1c0-2.5,0.6-4.6,1.9-6.2c1.3-1.7,3-2.9,5.2-3.8c2.2-0.9,4.6-1.3,7.4-1.3c2.9,0,5.7,0.4,8.2,1.3 c2.5,0.8,4.5,2.1,6,3.7c1.5,1.6,2.3,3.7,2.3,6.1c0,2.7-0.8,4.9-2.3,6.6c-1.5,1.7-3.7,2.9-6.5,3.5v-0.1c1.2,0.6,2.3,1.2,3.2,2 c0.9,0.8,1.6,1.7,2.1,2.7c0.5,1,0.7,2.1,0.7,3.3c0,2.6-0.7,4.7-2,6.4c-1.4,1.7-3.2,3-5.5,3.9C86.6,40.6,84.1,41,81.2,41z  M80.3,32.4c1,0,1.8-0.2,2.5-0.5c0.7-0.4,1.2-0.9,1.6-1.5c0.4-0.6,0.5-1.4,0.5-2.2c0-0.8-0.2-1.6-0.7-2.2c-0.5-0.6-1.1-1.1-1.9-1.4 c-0.8-0.3-1.7-0.5-2.8-0.5c-0.9,0-1.7,0.2-2.4,0.6c-0.7,0.4-1.2,0.9-1.6,1.5c-0.4,0.6-0.5,1.4-0.5,2.2c0,0.8,0.2,1.5,0.7,2.1 c0.4,0.6,1.1,1.1,1.9,1.4C78.3,32.2,79.3,32.4,80.3,32.4z M83.7,16.8c0.9,0,1.7-0.2,2.3-0.5c0.6-0.4,1.1-0.9,1.5-1.5 c0.4-0.6,0.5-1.3,0.5-2.1c0-1.1-0.4-2-1.2-2.7c-0.8-0.7-1.9-1-3.3-1c-1,0-1.8,0.2-2.4,0.6c-0.7,0.4-1.2,0.9-1.5,1.5 c-0.3,0.6-0.5,1.3-0.5,2c0,0.7,0.2,1.4,0.6,1.9c0.4,0.6,0.9,1,1.6,1.4C81.9,16.7,82.7,16.8,83.7,16.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d83388fc21030a90e7d52541fcb5e68b.svg";
export { ForwardRef as ReactComponent };